import React, { useContext, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import firebase from 'gatsby-plugin-firebase';

import { StoreContext } from '../../context/StoreContext';
import { FirebaseContext } from '../../context/FirebaseContext';

import { media } from '../helpers';

import WishlistButton from '../product-components/product-wishlist-button';

const ProductAddToCartContainer = styled.div`
    padding-top: 30px;
    > .inner-wrap {
        display: flex;

        .btn-container {
            flex: 0 0 50%;
            ${media.medium`flex: 0 0 40%;`}
            ${media.large`flex: 0 0 35%;`}
            ${media.laptop`flex: 0 0 25%;`}
            button {
                line-height: 1;
                padding: 21px 0;

                width: 100%;
                display: inline-block;
                font-size: 1rem;
                ${media.small`max-width: 170px;`}
                ${media.medium`max-width: 210px;`}
            }
            &:first-child {
            }

            &.addtocart {
                flex: 1 1 100%;
                ${media.small`margin-right: 10px;`}
                ${media.medium`flex: 0 0 40%;`}
                ${media.large`flex: 0 0 35%;`}
                ${media.laptop`flex: 0 0 25%;`}
                button {
                    color: #fff;
                    background-color: #f74d33;
                    font-weight: 700;
                    border: 1px solid #f74d33;
                    border-radius: 5px;
                }
            }
            &.desktop-only {
                display: none;
                ${media.large`display: inline-block;`}
            }
        }
    }
`;

const ProductAddToCart = ({ currentVariant, handle, qty }) => {
    const { shopifyId } = currentVariant || {};

    const { addProductToCart } = useContext(StoreContext);
    const { user } = useContext(FirebaseContext);

    function handleAddToCart(shopifyID) {
        addProductToCart(shopifyID, qty);
    }

    return (
        <ProductAddToCartContainer>
            <div className="inner-wrap">
                <div className="btn-container addtocart">
                    <button onClick={() => handleAddToCart(shopifyId)}>
                        Add to cart
                    </button>
                </div>
                <div className="btn-container desktop-only">
                    <WishlistButton
                        handle={handle}
                        currentVariant={currentVariant}
                    />
                </div>
            </div>
        </ProductAddToCartContainer>
    );
};

export default ProductAddToCart;
